import http from './http-common';
class UserService {
    getProfile() {
        return http.get('/user/me');
    }

    getUser(id) {
        return http.get(`/user/${id}`);
    }

    getUsageDetails() {
        return http.get('/v2/user/me/usage');
    }

    updateProfile(data) {
        return http.put('/user/me', data);
    }

    updateSilenceTimeout(silenceTimeout) {
        return http.put('/user/preferences/silence-timeout', { silenceTimeout });
    }

    getConversations() {
        return http.get(`/v2/user/me/conversation`);
    }

    getPlannedSessions() {
        return http.get(`/v2/user/me/planned-sessions`);
    }

    getPlannedSession(sessionId) {
        return http.get(`/v2/planned-session/get/${sessionId}`);
    }

    changePassword(data) {
        return http.put('/user/me/change-password', data);
    }

    async downloadFile(data) {

        //Pour les fichiers avec une transcription Azure générée en batch
        if(data.azure_transcription && data.azure_transcription.status === 'completed'){
            return http.get(`/batch-file/transcription/${data._id}/export.zip`,{
                method: 'GET',
                responseType: 'blob', // important
          });
        }
        else{
            return http.get(`/session/${data._id}/download`,{
                method: 'GET',
                responseType: 'blob', // important
          });
        }
     
    }

    async deleteFile(data) {
        return http.get(`/session/${data._id}/delete-transcription`,{
            method: 'GET'
          });
    }
}

export default new UserService();
